import React from 'react'
import user from '../../../../resources/images/user.svg'
import PropTypes from 'prop-types'
// import AlertContainer from 'react-alert'
import { locale, polyglot, dataAppStorage, dataAppDatabase } from '../../../../index'
import { getAgeDescription, getFormattedBirthDate } from '../../../../resources/utilities'
import { ReactModal } from '../../../common/ReactModal/ReactModal'

export default class Patient extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false
    }
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  render () {
    return (
      <div className='row center'>
        {/* <AlertContainer ref={a => { this.msg = a }} {...alertOptions} /> */}
        <div className='col-sm-12 col-md-12'>
          <div className='thumbnail'>
            <img className='patient-photo' onClick={this.toggleModal}
              src={this.props.patient.photo ? this.props.patient.photo : user} alt={polyglot.t('staticText.profilePhoto')} />
            <div className='caption'>
              <h2>{this.props.patient.name}</h2>
              <h5><span />{polyglot.t('patient.birthDate')} - {getFormattedBirthDate(this.props.patient.birthDate)}</h5>
              <h5>{polyglot.t('commonFields.age')} - {getAgeDescription(this.props.patient.birthDate)}</h5>
            </div>
          </div>
        </div>
        <ReactModal name={polyglot.t('staticText.photo')} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen}>
          <PhotoInputForm
            // alertMsg={this.msg}
            patientKey={this.props.patientKey}
            patient={this.props.patient}
            toggleModal={this.toggleModal} />
        </ReactModal>
      </div>
    )
  }
}

Patient.propTypes = {
  patient: PropTypes.object.isRequired,
  patientKey: PropTypes.string.isRequired
}

class PhotoInputForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      btnIsActive: false,
      loading: ''
    }
    this.handlePictureChange = this.handlePictureChange.bind(this)
    this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this)
  }
  handlePictureChange (e) {
    if (e.target.files && e.target.files[0]) {
      const reader = new window.FileReader()
      reader.onload = (e) => {
        this.refs.profilePicture.src = e.target.result
        this.setState({
          btnIsActive: true
        })
      }
      reader.readAsDataURL(e.target.files[0])
    }
  }

  handlePhotoSubmit (e) {
    e.preventDefault()
    this.setState({
      loading: 'cursor-loading'
    })
    if (e.target.pic.files[0].size > 1000000) {
      // this.props.alertMsg.error(polyglot.t('staticText.maxFileSizeWarning'))
      this.setState({
        loading: ''
      })
    } else {
      const storageRef = dataAppStorage.ref()
      storageRef.child(`userImages/${this.props.patient.patientNumber}`).put(e.target.pic.files[0]).then((snapshot) => {
        if (snapshot.state === 'success') {
          const patientRef = dataAppDatabase.ref().child('riso').child('patientsByCountry').child(locale).child(this.props.patientKey).child('photo')
          patientRef.set(snapshot.metadata.downloadURLs[0])
          // this.props.alertMsg.success(polyglot.t('patient.photoChangedSuccessfully'))
          this.props.toggleModal()
        } else {
          // this.props.alertMsg.error(polyglot.t('patient.errorOnPhotoUpload'))
        }
        this.setState({
          loading: ''
        })
      })
    }
  }

  render () {
    return <form className={`form-horizontal ${this.state.loading}`} onSubmit={(e) => this.handlePhotoSubmit(e)}>
      <div className='form-group'>
        <div className='col-xs-12 col-sm-6 center padding-input'>
          <img ref={'profilePicture'} className='patient-photo'
            src={this.props.patient.photo ? this.props.patient.photo : user} alt={polyglot.t('staticText.profilePhoto')} />
        </div>
        <div className='col-xs-12 col-sm-6 center'>
          <span className='btn btn-default btn-file'>{polyglot.t('staticText.selectImage')}
            <input type='file' maxLength={100000} accept='image/*' name='pic' onChange={(e) => this.handlePictureChange(e)} />
          </span>
        </div>
      </div>
      <div className='modal-footer'>
        <button type='submit' disabled={!this.state.btnIsActive} className='btn btn-primary'>{polyglot.t('commonFields.saveChanges')}</button>
      </div>
    </form>
  }
}

PhotoInputForm.propTypes = {
  alertMsg: PropTypes.object,
  patientKey: PropTypes.string.isRequired,
  patient: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Home/Patient/Patient.js